import { useQuery } from '@tanstack/react-query';

type FamilyRole = {
  id: string;
  name: string;
};

export const useFamilyRoles = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data, isLoading, error } = useQuery<FamilyRole[]>({
    queryKey: ['family-roles'],
    enabled,
  });

  const familyRoles = data ?? [];

  return {
    familyRoles,
    // Every caller that labels a member needs the roles by id, so the lookup is built once here
    // rather than re-derived at each call site.
    roleNameById: Object.fromEntries(familyRoles.map(role => [role.id, role.name])),
    isLoading,
    error,
  };
};
